import React from "react"

import "flatpickr/dist/themes/material_blue.css"

import { Button, Col, Modal, ModalBody, ModalHeader } from "reactstrap"

import greenCheckIcon from "../../../assets/images/icons/greenCheckIcon.svg"

function SuccessRequestModal({ open, setOpen }) {
  return (
    <Modal
      isOpen={open}
      toggle={() => {
        setOpen((prev) => !prev)
      }}
      size="md"
      centered={true}
    >
      <ModalHeader
        toggle={() => {
          setOpen((prev) => !prev)
        }}
      ></ModalHeader>
      <ModalBody>
        <div className="success-request-modal">
          <Col xl={12}>
            <div className="icon-section">
              <img src={greenCheckIcon} alt="" />
            </div>
            <h4>ICD Request Submitted Successfully!</h4>
            <p>
              The Prachay Admin team will now review your request. You’ll be
              notified once the request is approved, rejected, or a counteroffer
              is made.
            </p>

            <div>
              <button
                type="submit"
                className="btn btn-primary w-md"
                onClick={() => setOpen(true)}
              >
                View My ICD Requests
              </button>
            </div>
            <div>
              <button type="submit" className="btn btn-cancel w-md">
                Close
              </button>
            </div>
          </Col>
        </div>
      </ModalBody>
    </Modal>
  )
}

export default SuccessRequestModal
